import './Status.css'
import { Text } from '../units/Text'
import { FlexWrapper } from '../Wrappers/Wrappers'

export const BadStatus = () => {
    return (
        <FlexWrapper alignItems='center' justifyContent='center' className='status-wrapper bg-danger'>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L1 13M13 13L1 1.00001" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        </FlexWrapper>
    )
}